import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function TaxInfo({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Tax Information</b>
          </p>
          <p>
            Tax information types are used to capture details on the taxability
            and tax code for a transaction or line. It follows the structure
            below.
            <pre>
              <code>
                {`
{
  taxable: boolean: Is this taxable
  taxCode: reference: reference to tax code
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
TaxInfo.propTypes = {
  type: PropTypes.string.isRequired
};
